angular
  .module('app.core')

  .constant('API', {
    url: 'https://api.coaunity.com',
    version: 1
  });